export default "__VITE_ASSET__BahrckEW__"